import * as React from "react";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {none, Option} from "ts-option";
import {default as DropDownList, DropDownItem} from "../../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import TextUtils from "../../../../utils/TextUtils";
import Toast from "../../../helper/Toast";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import DescriptionModal from "./DescriptionModal";
import UserMention from "../../../mention/UserMention";
import {IMentionData} from "react-mentions";
import {OnSuccess} from "../../../../store/action/actionHelpers";
import MentionUtils from "../../../../utils/MentionUtils";
import Job from "../../../../model/job/Job";
import {editJob} from "../../../../store/action/job/job";
import {api} from "../../../../api/api";
import _ = require("underscore");

interface ComponentProps {
	/**
	 * Job.
	 */
	job: Option<Job>
}

interface IDispatchProps {
	/**
	 * Edit job action.
	 * @param {Job} job
	 */
	editJob: (job: Job, onSuccess: OnSuccess) => void;
}

interface IState {
	menuDropDownVisible: boolean;
	editBoxVisible: boolean;
}

type Props = ComponentProps & IDispatchProps

class JobDescription extends React.PureComponent<Props, IState> {

	selectedDescriptionMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
		{id: "l3", label: "Copy"},
	];

	emptyDescriptionMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
	];

	constructor(props: Props) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			editBoxVisible: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onDescriptionChange = this.onDescriptionChange.bind(this);
	}

	render() {
		const menuItems = this.props.job.isDefined && this.props.job.get.data.description.isDefined ?
			this.selectedDescriptionMenu : this.emptyDescriptionMenu;
		return (
			<InfoModule icon={Icon.Description} title={"DESCRIPTION"} actionIcon={Icon.Overflow}
						onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.editBoxVisible &&
				<DescriptionModal value={this.props.job.map(j => j.data.extendedDescription).getOrElse(none)}
								  title={"Job description"}
								  onChange={(value, mentions) => this.setState({editBoxVisible: false},
									  () => {this.onDescriptionChange(value, mentions)})}
								  onClose={() => this.setState({editBoxVisible: false})}/>}
				{
					this.props.job.map(j => {
						return (
							<span className="t-body">
								{j.data.extendedDescription.map(d => <UserMention value={d} readonly/>).getOrElse(
									<span>Description not provided</span>)}
							</span>
						)
					}).getOrElse(<span className="t-body">Description not provided</span>)
				}
			</InfoModule>
		);
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({menuDropDownVisible: false, editBoxVisible: true});
				break;
			case "l2":
				this.setState({menuDropDownVisible: false, editBoxVisible: false},
					() => {this.onDescriptionChange(none, [])});
				break;
			case "l3":
				this.props.job.map(c => c.data.description.map(d => TextUtils.copyToClipboard(d)));
				break;

		}
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onDescriptionChange(value: Option<string>, mentions: IMentionData[]) {
		this.props.job.map(j => {
			const updatedJob = j.copy(
				{
					data: j.data.copy(
						{description: value.map(v => MentionUtils.getPlainText(v, true)), extendedDescription: value})
				});
			this.props.editJob(updatedJob, () => this.onJobUpdateSuccess(mentions));
		})
	}

	onJobUpdateSuccess(mentions: IMentionData[]) {
		Toast.success("Job description updated", "Job details update");
		this.mentionUsers(mentions);
	}

	private mentionUsers(mentions: IMentionData[]) {
		const uniqueUsers = _.uniq(mentions.map(m => m.id));
		if (uniqueUsers.length)
			this.props.job.map(j =>
				api.instance.jobApi.mentionUsers(j.id, uniqueUsers).catch(() => Toast.error("Mention users error")));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editJob: (job: Job, onSuccess: OnSuccess) => dispatch(
			editJob(
				job,
				onSuccess,
				() => Toast.error("Sorry, something went wrong. Try again later.", "Job details update"))
		),
	}
}

export default connect(null, mapDispatchToProps)(JobDescription)